import isObject$1 from './is-object.js';
import createNonEnumerableProperty$1 from './create-non-enumerable-property.js';

var isObject = isObject$1;
var createNonEnumerableProperty = createNonEnumerableProperty$1; // `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause

var installErrorCause = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};

export { installErrorCause as default };
